import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureMabiEStatementsEnrollAccountSummary(props) {
    return <AccountSummaryPage />
}